// "Copy report" in the owner-only LegalWatch report (templates/articles/legal-watch-status.ejs):
// copies the server-built text that the "Download TXT" link also carries.
export function initLegalWatchExport(actions: HTMLElement): void {
    const button = actions.querySelector<HTMLButtonElement>('[data-legal-watch-copy]')!;
    const status = actions.querySelector<HTMLElement>('[role="status"]')!;
    const text = actions.parentElement!.querySelector<HTMLElement>('[data-legal-watch-text]')!.textContent!;

    button.addEventListener('click', async () => {
        try {
            await navigator.clipboard.writeText(text);
            status.textContent = actions.dataset.copied!;
        } catch {
            // No clipboard (insecure context, denied permission): the download link still works.
            status.textContent = actions.dataset.copyFailed!;
        }
    });
}
